import {
  FillInTheBlanksAreaPinComponentEditor,
  FillInTheBlanksAreaPinComponentEditorProps,
} from '@lessonup/pin-renderer';
import React from 'react';
import { useEditMode } from '../../../../context/EditorContext/hooks/useEditorState';

export const FillInTheBlanksAreaEditorPinComponent = (props: FillInTheBlanksAreaPinComponentEditorProps) => {
  const editMode = useEditMode();
  const isPreviewMode = editMode.type === 'preview';

  return <FillInTheBlanksAreaPinComponentEditor {...props} isPreviewMode={isPreviewMode} />;
};
